import Icon from '../components/Icon.vue'

Icon.register({
  'broadcast-tower': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M150.9 192H184.7C195.7 192 203.3 181.2 199.5 170.8 194.6 157.2 192 142.8 192 128S194.6 98.8 199.5 85.2C203.3 74.8 195.7 64 184.7 64H150.9C143.9 64 137.5 68.5 135.5 75.2 130.6 92.2 128 109.9 128 128 128 146.1 130.6 163.8 135.5 180.8 137.5 187.5 143.9 192 150.9 192zM89.9 23.3C95.6 12.7 88 0 76 0H40.6C34.4 0 28.5 3.6 25.9 9.3 9.4 45.5 0 85.6 0 128 0 152.8 3.1 196.3 26.7 246.9 29.3 252.5 35.1 256 41.3 256H76.1C88.2 256 95.8 243.3 90.1 232.6 40.3 139.3 73.4 54.5 89.9 23.3zM614.1 9.3C611.5 3.6 605.6 0 599.3 0H563.9C551.9 0 544.3 12.7 549.9 23.3 568.2 57.5 598.3 142.7 550.2 232.5 544.5 243.2 552 256 564.1 256H599.3C605.6 256 611.4 252.4 614 246.7 630.6 210.5 640 170.4 640 128S630.6 45.5 614.1 9.3zM489.1 64H455.3C444.3 64 436.7 74.8 440.5 85.2 445.4 98.8 448 113.2 448 128S445.4 157.2 440.5 170.8C436.7 181.2 444.3 192 455.3 192H489.1C496.1 192 502.5 187.5 504.5 180.8 509.4 163.8 512 146.1 512 128 512 109.9 509.4 92.2 504.5 75.2 502.5 68.5 496.1 64 489.1 64zM372.8 164.1C379.8 153.8 384 141.4 384 128 384 92.6 355.3 64 320 64 284.7 64 256 92.6 256 128 256 141.4 260.2 153.8 267.2 164.1L136.7 477.5C133.3 485.7 137.2 495.1 145.3 498.4L174.9 510.8C183 514.2 192.4 510.3 195.8 502.1L245 384H395L444.2 502.1C447.6 510.3 457 514.2 465.1 510.8L494.6 498.4C502.8 495.1 506.6 485.7 503.3 477.5L372.8 164.1zM271.6 320L320 203.8 368.4 320H271.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/broadcast-tower.js
// module id = tdQd
// module chunks = 144